<template>
  <div>
    <SmartModal v-if="modal" v-bind="modal" @close="onCloseModal">
      {{ modal.text }}
    </SmartModal>
    <v-idle @idle="onidle" :loop="true" :duration="900" hidden />
  </div>
</template>
<script>

export default {
  name: "SmartInactivityTimer",
  data() {
    return {
      modal: null,
    };
  },

  methods: {
    onidle() {
      if (localStorage.token) {
        this.forceLogout();
        this.modal = {
          type: "warning",
          title: "Usuário deslogado",
          icon: "alert",
          buttonText: "Ok",
          text: "Devido à inatividade, o usuário foi deslogado. Para continuar, faça login novamente.",
        };
      }
    },
    forceLogout() {
      localStorage.removeItem("token");
    },

    onCloseModal() {
      this.$router.push("/");
      this.modal = null;
    }
  },
};
</script>
